/**
 * Build a CSS url() value that survives uploaded filenames.
 *
 * An uploaded file keeps its original name, so paths routinely contain spaces
 * ("11-11 Skool Cover.jpg"). Interpolated raw, `url(/path/My File.jpg)` is invalid CSS and the
 * browser drops the whole declaration — the image silently never appears, which is what
 * happened to a vendor banner (owner, Jun 2026). Encode it and quote it.
 */
export const cssUrl = (url) =>
  url ? `url("${encodeURI(url).replace(/"/g, '%22')}")` : 'none';

export default cssUrl;
